import { nextTick, ref } from '@vue/composition-api';

const muted = ref(true);
const videos = ref([]);
const remoteVideos = ref([]);

export default function useVideo() {
  async function play(video) {
    if (!video) {
      console.error('Video element is not defined');
      return;
    }

    if (!video.paused) {
      return;
    }

    const maxAttempts = 5;
    const intervalMs = 500;
    let attempts = 0;

    const tryPlay = async () => {
      attempts++;

      try {
        const playPromise = video.play();

        if (playPromise !== undefined) {
          await playPromise;
          return true;
        }
        if (!video.paused) {
          return true;
        }
        return false;
      } catch (error) {
        console.error(`Video play attempt ${attempts} failed:`, error);
        return false;
      }
    };

    if (await tryPlay()) {
      return;
    }

    const intervalId = setInterval(async () => {
      if (attempts >= maxAttempts) {
        clearInterval(intervalId);
        console.error('Failed to start video playback after max attempts');
        return;
      }

      if (await tryPlay()) {
        clearInterval(intervalId);
      }
    }, intervalMs);
  }

  function setSrc(video, src) {
    try {
      // eslint-disable-next-line no-param-reassign
      video.srcObject = src;
      // eslint-disable-next-line no-empty
    } catch (e) {
      console.error('Failed to set video srcObject:', e);
    }
  }

  function unMute() {
    muted.value = false;
  }

  function muteTracks(state) {
    remoteVideos.value.forEach((v) => {
      // eslint-disable-next-line no-param-reassign
      v.enabled = !state;
    });
  }

  async function setVideo(stream, videoRef, data) {
    if (!stream.value) {
      return;
    }
    await nextTick();
    setSrc(videoRef.value, stream.value);
    videos.value.push({ video: videoRef.value, data });
    await play(videoRef.value);
  }

  return {
    play,
    unMute,
    muted,
    setVideo,
    videos,
    remoteVideos,
    muteTracks,
  };
}
